import { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import './Main.scss'
import axios from 'axios';
import MainURL from '../../MainURL';
import ImageURL from '../../ImageURL';
import { useAtomValue } from 'jotai';
import { loginStateAtom, userDataAtom } from '../../AtomStore';
import { useNavigate } from 'react-router-dom';
import kakaologo from "../../images/login/kakao.png"
import instarlogo from "../../images/instarlogo.jpeg"
import appStoreIcon from '../../images/App_store_icon.png';
import playStoreIcon from '../../images/playstore.png';
import { FaArrowRight, FaAngleDoubleRight } from "react-icons/fa";
import Header from '../../components/Header';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import { isMemberUser } from '../login/userTypeUtils';
import { motion } from "framer-motion";
import type { MinisterInfoListItem } from '../minister/pages/ministerInfo/ministerInfoTypes';
import { USE_MINISTER_MOCK, filterMockMinisterList } from '../minister/pages/ministerInfo/ministerInfoMock';
import { profileImageSrc } from '../minister/pages/ministerInfo/ministerInfoUtils';
import { roleMarkerClass } from '../../utils/roleMarker';
import MainSlider from './MainSlider';

const APP_STORE_URL =
  'https://apps.apple.com/kr/app/%EC%82%AC%EC%97%AD%EC%9E%90%EB%AA%A8%EC%95%84/id6771267063';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.ministermore&pcampaignid=web_share';

function getTodayDateString() {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}


interface RecruitProps {
  id: string;
  title: string;
  source: string;
  writer: string;
  date: string;
  church: string;
  religiousbody: string;
  location: string;
  locationDetail: string;
  address: string;
  mainpastor: string;
  homepage: string;
  school: string;
  career: string;
  sort: string;
  part: string;
  partDetail: string;
  recruitNum: string;
  workday: string;
  workTimeSunDay: string;
  workTimeWeek: string;
  dawnPray: string;
  pay: string;
  welfare: string;
  insurance: string;
  severance: string;
  applydoc: string;
  applyhow: string;
  applytime: string;
  etcNotice: string;
  inquiry: string;
  churchLogo: string;
  customInput: string;
}

interface NewsProps {
  id: number;
  title: string;
  source: string;
  writer: string;
  date: string;
  link: string;
  thumbnail: string;
}

interface NewsBySource {
  [key: string]: NewsProps[];
}

interface PlaceItem {
  id: number;
  isView: string | boolean | number | null;
  placeName: string;
  sort: string;
  region: string;
  location: string;
  size: string;
  images: string | string[] | null;
}

const MAIN_RECRUIT_DISPLAY_COUNT = 9;
const MAIN_PLACE_PAGE_SIZE = 6;
const MAIN_MINISTER_DISPLAY_COUNT = 6;

const getFirstPlaceImage = (images: PlaceItem['images']) => {
  if (!images) return '';
  if (Array.isArray(images)) return images[0] || '';
  try {
    const parsed = JSON.parse(images);
    return Array.isArray(parsed) ? parsed[0] || '' : '';
  } catch {
    return images;
  }
};



export default function Main(props:any) {

	let navigate = useNavigate();
  const isLogin = useAtomValue(loginStateAtom);
	const userData = useAtomValue(userDataAtom);
  const [recruitList, setRecruitList] = useState<RecruitProps[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [ministerList, setMinisterList] = useState<MinisterInfoListItem[]>([]);
  const [isMinisterLoading, setIsMinisterLoading] = useState<boolean>(true);
  const [placeList, setPlaceList] = useState<PlaceItem[]>([]);
  const [isPlaceLoading, setIsPlaceLoading] = useState<boolean>(true);
  const [newsBySource, setNewsBySource] = useState<NewsBySource>({});
  const [isNewsLoading, setIsNewsLoading] = useState<boolean>(true);
  const [activeTab, setActiveTab] = useState<'denomination' | 'school'>('denomination');
  const [listNotice, setListNotice] = useState<any[]>([]);
  const [myIp, setMyIp] = useState<string>('');
  const [todayVisitors, setTodayVisitors] = useState<number>(0);
  const [totalMembers, setTotalMembers] = useState<number>(0);
  const [totalRecruit, setTotalRecruit] = useState<number>(0);
  const [totalPlace, setTotalPlace] = useState<number>(0);

  const religiousbodyList = [
    {name: "구세군대한본영", home: "https://www.thesalvationarmy.or.kr/"},
    {name: "기독교대한감리회", home: "https://kmc.or.kr/"},
    {name: "기독교대한성결교회", home: "https://www.kehc.org/"},
    {name: "기독교대한하나님의성회", home: "http://agk.or.kr/"},
    {name: "기독교한국침례회", home: "http://www.koreabaptist.or.kr/"},
    {name: "대한기독교나사렛성결회", home: "https://na.or.kr/"},
    {name: "대한예수교장로회고신", home: "http://kosin.org/"},
    {name: '대한예수교장로회백석', home: 'https://www.pgak.net/' },
    {name: "대한예수교장로회통합", home: "https://www.pck.or.kr/"},
    {name: "대한예수교장로회합동", home: "https://alpha.gapck.org/"},
    {name: "대한예수교장로회합신", home: "https://www.hapshin.org/"},
    {name: "예수교대한성결교회", home: "https://www.sungkyul.org/"},
    {name: "한국기독교장로회", home: "https://www.prok.org/gnu/index.php"},
    {name: "독립교단(KAICAM)", home: "https://home.kaicam.org/index.asp"}
  ];
  const schoolList = [
    {name: "고려신학대학원", home: "https://www.kts.ac.kr/home/"},
    {name: "광신대학교", home: "https://www.kwangshin.ac.kr/home/index.do"},
    {name: "구세군군사관대학원대학교", home: "https://gufot.ac.kr"},
    {name: "대전신학대학교", home: "https://www.daejeon.ac.kr"},
    {name: "대신대학교", home: "https://www.daeshin.ac.kr/html/00_main/"},
    {name: '백석대학교대학원', home: 'https://community.bu.ac.kr/graduateschool/index.do' },
    {name: "부산장신대학교", home: "https://www.bpu.ac.kr/Default.aspx"},
    {name: "서울장신대학교", home: "https://www.sjs.ac.kr"},
    {name: "서울신학대학교신대원", home: "https://gs.stu.ac.kr/CmsHome/StuGs0207_0101.eznic"},
    {name: "성결교신대원", home: "http://www.skts.org/"},
    {name: "영남신학대학교", home: "https://www.ytus.ac.kr/html/index.php"},
    {name: "웨스트민스터신학대학원대학교", home: "http://www.wgst.ac.kr/wgst_renew"},
    {name: "장로회신학대학교", home: "https://www.puts.ac.kr"},
    {name: "총신대학교", home: "https://www.csu.ac.kr/"},
    {name: "한세대학교", home: "https://www.hansei.ac.kr/sites/kor/index.do"},
    {name: "한신대학교", home: "https://www.hs.ac.kr/gradseoulcampus/index.do"},
    {name: "한일장신대학교", home: "https://www.hanil.ac.kr"},
    {name: "한국침례신학대학교신대원", home: "https://gtheology.kbtus.ac.kr/gtheology/Main.do"},
    {name: "호남신학대학교", home: "https://www.htus.ac.kr/index.php#"}
  ];


  const fetchRecruitList = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${MainURL}/recruitminister/getrecruitformain`);
      if (res.data.resultData) {
        setRecruitList((res.data.resultData as RecruitProps[]).slice(0, MAIN_RECRUIT_DISPLAY_COUNT));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // 사역자정보 목록과 동일 — 공개 이력서(최신순)를 먼저, 부족하면 목데이터로 채운다
  const fetchMinisterList = async () => {
    let real: MinisterInfoListItem[] = [];
    let registeredTitles: string[] = [];
    try {
      setIsMinisterLoading(true);
      const res = await axios.get(`${MainURL}/resume/ministerlist`, {
        params: { userAccount: userData.userAccount, page: 1, search: '', hopeType: '', city: '', gender: '' },
      });
      if (res.data.success) {
        real = res.data.list || [];
        registeredTitles = res.data.registeredMockTitles || [];
      }
    } catch (error) {
      console.log(error);
    } finally {
      const registered = new Set(registeredTitles);
      const mocks = USE_MINISTER_MOCK
        ? filterMockMinisterList({ search: '', hopeType: [], city: [], gender: '' }).filter((item) => !registered.has(item.title))
        : [];
      setMinisterList([...real, ...mocks].slice(0, MAIN_MINISTER_DISPLAY_COUNT));
      setIsMinisterLoading(false);
    }
  };

  const fetchPlaceList = async () => {
    try {
      setIsPlaceLoading(true);
      const res = await axios.post(`${MainURL}/retreat/getdataplace`, {
        region: 'all',
        sort: 'all',
        page: 1,
        pageSize: MAIN_PLACE_PAGE_SIZE,
      });
      if (res.data.data) {
        setPlaceList(res.data.data as PlaceItem[]);
        if (typeof res.data.count === 'number') setTotalPlace(res.data.count);
      } else {
        setPlaceList([]);
      }
    } catch (error) {
      console.log(error);
      setPlaceList([]);
    } finally {
      setIsPlaceLoading(false);
    }
  };

  const fetchDynamicStats = async () => {
    // 오늘 방문자·회원 수는 숫자만 주는 공개 API 사용 (관리자 통계·회원 목록 API 는 관리자 전용)
    try {
      const res = await axios.get(`${MainURL}/publicstats/summary`, { params: { date: getTodayDateString() } });
      setTodayVisitors(Number(res.data?.todayVisitors ?? 0) * 3);
      setTotalMembers(Number(res.data?.totalMembers ?? 0));
    } catch {}

    try {
      const res = await axios.get(`${MainURL}/recruitminister/getrecruitdata/1`);
      setTotalRecruit(Number(res.data?.totalCount ?? 0));
    } catch {}
  };

  const openPlaceDetail = (id: number) => {
    if (!isLogin) {
      alert('로그인이 필요합니다.');
      return;
    }
    if (userData.grade === '일반회원') {
      alert('등업이 필요합니다. 등업신청 게시판에서 신청해주세요');
      return;
    }
    window.scrollTo(0, 0);
    navigate(`/retreat/place/detail?id=${id}`);
  };

  const renderPreview = (content: string, maxLength: number) => {
    if (content?.length > maxLength) {
      return content.substring(0, maxLength) + '...';
    }
    return content;
  };

  const fetchNews = async () => {
    try {
      setIsNewsLoading(true);
      const res = await axios.get(`${MainURL}/news/getnewsdata`);
      if (res.data.resultData) {
        setNewsBySource(res.data.groupedBySource || {});
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsNewsLoading(false);
    }
  };

  const handleMinisterRecruitAccess = (action: () => void) => {
    if (isMemberUser(userData.userType)) {
      alert('일반 성도 회원은 사역자 구인구직 메뉴에 접근할 수 없습니다.');
      return;
    }
    action();
  };

  const countUp = (type: string) => {
    const date = getTodayDateString();
    axios
      .post(`${MainURL}/admin/countup`, { date, type })
      .then(() => {})
      .catch((error) => { console.log(error); });
  };

  useEffect(() => {
    if (myIp) {
      countUp('mainconnect');
    }
  }, [myIp]);

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then(res => res.json())
      .then(data => {
        setMyIp(data.ip);
        axios.post(`${MainURL}/admin/homeusercount`, { date: getTodayDateString(), ip: data.ip });
      })
      .catch(() => { setMyIp(''); });
  }, []);

  useEffect(()=>{
    fetchRecruitList();
    fetchMinisterList();
    fetchPlaceList();
    fetchNews();
    fetchDynamicStats();
  }, []);


	return (
		<div className='main'>
      <Header/>

      {/* 슬라이드 이미지 — 관리자 > 메인 슬라이드에서 관리, 등록된 것이 없으면 표시 안 함 */}
      <div className="main__inner main__slider__wrap">
        <MainSlider />
      </div>

      {/* 히어로 — 명조 제목 + 선으로 구분한 통계 */}
      <section className="main__hero">
        <div className="main__inner">
          <span className="main__hero__kicker">사역자 · 교회 연결 플랫폼</span>
          <h2 className="main__hero__title mm-serif">사역자와 교회를<br />가장 정확하게 연결합니다</h2>
          <p className="main__hero__lede">
            전국 교회의 청빙 공고와 사역자 이력서를 한 곳에서. 부서·지역·직분으로 찾고 바로 지원하세요.
          </p>
          <div className="main__stats__grid">
            <div className="main__stat">
              <div className="main__stat__num mm-serif">{todayVisitors.toLocaleString('ko-KR')}</div>
              <div className="main__stat__label">오늘 접속자</div>
            </div>
            <div className="main__stat">
              <div className="main__stat__num mm-serif">{totalMembers.toLocaleString('ko-KR')}</div>
              <div className="main__stat__label">사역자모아 회원</div>
            </div>
            <div className="main__stat">
              <div className="main__stat__num mm-serif">{totalRecruit.toLocaleString('ko-KR')}</div>
              <div className="main__stat__label">채용 공고</div>
            </div>
            <div className="main__stat">
              <div className="main__stat__num mm-serif">{totalPlace.toLocaleString('ko-KR')}</div>
              <div className="main__stat__label">수련회 장소</div>
            </div>
          </div>
        </div>
      </section>

      {/* 앱 안내 — 선 공지 */}
      <div className="main__inner">
        <div className="main__app__line">
          <p className="main__app__adv__text">'사역자모아' 앱을 스토어에서 다운로드 받으실 수 있습니다</p>
          <div className="main__app__adv__badges">
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="main__app__adv__badge">
              <img src={appStoreIcon} alt="App Store에서 다운로드" />
              <span>App Store</span>
              <FaAngleDoubleRight className="main__app__adv__badge__arrow" />
            </a>
            <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="main__app__adv__badge">
              <img src={playStoreIcon} alt="Google Play에서 다운로드" />
              <span>Google Play</span>
              <FaAngleDoubleRight className="main__app__adv__badge__arrow" />
            </a>
          </div>
        </div>
      </div>

      {/* 채용공고 */}
      <section className="main__block">
        <div className="main__inner">
          <div className="main__sec__head">
            <div>
              <h2 className="main__sec__title mm-serif">최신 채용공고</h2>
              <p className="main__sec__desc">지금 사역자를 찾고 있는 교회들의 새로운 소식</p>
            </div>
            <button
              className="main__more__btn"
              onClick={() => handleMinisterRecruitAccess(() => { window.scrollTo(0, 0); navigate('/recruit'); })}
            >
              전체 채용공고 보기 <FaArrowRight />
            </button>
          </div>

          <div className="main__jobs__grid">
            {isLoading ? (
              <div className="main__placeholder"><p>채용공고를 불러오는 중...</p></div>
            ) : recruitList.length === 0 ? (
              <div className="main__placeholder"><p>현재 등록된 채용공고가 없습니다.</p></div>
            ) : (
              recruitList.slice(0, MAIN_RECRUIT_DISPLAY_COUNT).map((item) => {
                const part = item.part ? JSON.parse(item.part) : [{sort: '전임', content: ''}];
                const pay = item.pay ? JSON.parse(item.pay) : [{sort: '전임', paySort: 'select', selectCost: '', inputCost: ''}];
                const payText = (pay[0].inputCost === '교회내규에따라' || pay[0].inputCost === '협의후결정')
                  ? pay[0].inputCost
                  : pay[0].selectCost === '' && pay[0].inputCost !== ''
                    ? pay[0].inputCost
                    : pay[0].selectCost;

                return (
                  <article
                    key={item.id}
                    className="main__job__card"
                    onClick={() => handleMinisterRecruitAccess(() => {
                      countUp('recruitview');
                      navigate(`/recruit/minister/${item.id}`);
                      window.scrollTo(0, 0);
                    })}
                  >
                    <div className="main__job__body">
                      <div className="main__job__top">
                        <span className={roleMarkerClass(item.sort)}>{item.sort}</span>
                        <div className="main__job__church__row">
                          <img
                            src={`${MainURL}/siteimages/religiousbody/${item.religiousbody}.jpg`}
                            alt={item.religiousbody}
                            className="main__job__denom__logo"
                            onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
                          />
                          <span className="main__job__church">{item.church}</span>
                        </div>
                      </div>
                      <h3 className="main__job__title">{renderPreview(item.title, 40)}</h3>
                      <div className="main__job__meta">
                        {[`${item.location || ''} ${item.locationDetail || ''}`.trim(), part[0].content ? renderPreview(part[0].content, 12) : '', payText]
                          .filter(Boolean)
                          .map((text, i) => <span key={i} className="main__job__meta__item">{text}</span>)}
                      </div>
                      <div className="main__job__foot">
                        <span className="main__job__date">{item.date}</span>
                        <span className="main__job__apply">지원하기 →</span>
                      </div>
                    </div>
                  </article>
                );
              })
            )}
          </div>
        </div>
      </section>

      {/* 최신 등록된 사역자 */}
      <section className="main__block">
        <div className="main__inner">
          <div className="main__sec__head">
            <div>
              <h2 className="main__sec__title mm-serif">최신 등록된 사역자</h2>
              <p className="main__sec__desc">새롭게 이력서를 등록한 사역자들을 만나보세요</p>
            </div>
            <button
              className="main__more__btn"
              onClick={() => handleMinisterRecruitAccess(() => { window.scrollTo(0, 0); navigate('/minister'); })}
            >
              전체 사역자 보기 <FaArrowRight />
            </button>
          </div>

          <div className="main__jobs__grid">
            {isMinisterLoading ? (
              <div className="main__placeholder"><p>사역자정보를 불러오는 중...</p></div>
            ) : ministerList.length === 0 ? (
              <div className="main__placeholder"><p>현재 등록된 사역자가 없습니다.</p></div>
            ) : (
              ministerList.map((item) => {
                const latestCareer = item.careerItems[0];
                const latestEducation = item.educationItems[0];
                return (
                  <article
                    key={item.id}
                    className="main__job__card"
                    onClick={() => handleMinisterRecruitAccess(() => { window.scrollTo(0, 0); navigate('/minister'); })}
                  >
                    <div className="main__job__body">
                      <div className="main__minister__top">
                        {/* 사역자정보 목록과 동일하게 사진은 모자이크 */}
                        <div className="main__minister__avatar">
                          {item.profileImage ? (
                            <img src={profileImageSrc(item.profileImage)} alt="증명사진" draggable={false} />
                          ) : (
                            <span>{item.maskedName.slice(0, 1)}</span>
                          )}
                        </div>
                        <div className="main__minister__who">
                          <span className="main__job__church">{item.maskedName}</span>
                          <span className="main__minister__meta">
                            {[item.gender, item.ageText ? `만 ${item.ageText}세` : '', item.region].filter(Boolean).join(' · ') || '-'}
                          </span>
                        </div>
                        {item.hopeType && <span className={roleMarkerClass(item.hopeType)}>{item.hopeType}</span>}
                      </div>
                      <h3 className="main__job__title">{renderPreview(item.title || '제목 없음', 40)}</h3>
                      <dl className="main__minister__rows">
                        <div>
                          <dt>경력</dt>
                          <dd>
                            {latestCareer ? [latestCareer.companyName, latestCareer.position].filter(Boolean).join(' · ') : '-'}
                            {item.careerItems.length > 1 && ` 외 ${item.careerItems.length - 1}건`}
                          </dd>
                        </div>
                        <div>
                          <dt>학력</dt>
                          <dd>{latestEducation ? [latestEducation.schoolName, latestEducation.major].filter(Boolean).join(' · ') : '-'}</dd>
                        </div>
                        <div>
                          <dt>희망</dt>
                          <dd>{[item.hopeRoles, item.hopeDepartment].filter(Boolean).join(' / ') || '-'}</dd>
                        </div>
                        <div>
                          <dt>지역</dt>
                          <dd>{item.hopeLocation || '-'}</dd>
                        </div>
                      </dl>
                      <div className="main__job__foot">
                        <span className="main__job__date">수정일 {item.updatedAt}</span>
                        <span className="main__job__apply">자세히 보기 →</span>
                      </div>
                    </div>
                  </article>
                );
              })
            )}
          </div>
        </div>
      </section>

      {/* 수련회 장소 */}
      <section className="main__block main__retreat__bg">
        <div className="main__inner">
          <div className="main__sec__head">
            <div>
              <h2 className="main__sec__title mm-serif">수련회 장소</h2>
              <p className="main__sec__desc">전국 검증된 수련원과 기도원을 한눈에</p>
            </div>
            <button
              className="main__more__btn"
              onClick={() => { window.scrollTo(0, 0); navigate('/retreat/place'); }}
            >
              모든 장소 보기 <FaArrowRight />
            </button>
          </div>

          <div className="main__place__grid">
            {isPlaceLoading ? (
              <div className="main__placeholder"><p>수련회 장소를 불러오는 중...</p></div>
            ) : placeList.length === 0 ? (
              <div className="main__placeholder"><p>현재 등록된 수련회 장소가 없습니다.</p></div>
            ) : (
              placeList.map((place) => {
                const firstImage = getFirstPlaceImage(place.images);
                return (
                  <div key={place.id} className="main__place__card" onClick={() => openPlaceDetail(place.id)}>
                    <div className="main__place__thumb">
                      {firstImage ? (
                        <img src={`${ImageURL}/images/retreat/placeimage/${firstImage}`} alt={place.placeName} />
                      ) : (
                        <div className="main__place__noimg">등록된 사진이 없습니다.</div>
                      )}
                      <span className="main__place__badge">{place.location}</span>
                    </div>
                    <div className="main__place__body">
                      <div className="main__place__name">{place.placeName}</div>
                      <div className="main__place__meta">
                        <span>{place.sort}</span>
                        <span className="main__place__dot"></span>
                        <span>{place.size}</span>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </section>

      {/* 총회 / 신학교 */}
      <motion.section
        className="main__block"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <div className="main__inner">
          <div className="main__denomination__header">
            <div className="main__denomination__tabs">
              <button
                className={`main__denomination__tab ${activeTab === 'denomination' ? 'active' : ''}`}
                onClick={() => setActiveTab('denomination')}
              >총회 홈페이지</button>
              <button
                className={`main__denomination__tab ${activeTab === 'school' ? 'active' : ''}`}
                onClick={() => setActiveTab('school')}
              >신학교 홈페이지</button>
            </div>
          </div>
          <div className="main__denomination__grid">
            {(activeTab === 'denomination' ? religiousbodyList : schoolList).map((item, index) => (
              <div key={index} className="main__denomination__item">
                <button
                  className="main__denomination__button"
                  onClick={() => { if (item.home) window.open(item.home, '_blank'); }}
                >
                  <div className="main__denomination__image">
                    {activeTab === 'denomination' ? (
                      <img
                        className='main__denomination__image__denomination'
                        src={`${MainURL}/siteimages/religiousbody/${item.name}.jpg`}
                        alt={item.name}
                        onError={(e) => { e.currentTarget.src = `${MainURL}/images/altImage.jpeg`; }}
                      />
                    ) : (
                      <img
                        className='main__denomination__image__school'
                        src={`${MainURL}/siteimages/schoollogos/${item.name}.png`}
                        alt={item.name}
                        onError={(e) => { e.currentTarget.src = `${MainURL}/images/altImage.jpeg`; }}
                      />
                    )}
                  </div>
                  <div className="main__denomination__name"><p>{item.name}</p></div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* CTA */}
      <div className="main__cta">
        <div className="main__inner">
          <div className="main__cta__inner">
            <div className="main__cta__text">
              <h2 className="mm-serif">사역자와 교회를 <span className="main__cta__accent">연결합니다</span></h2>
              <p>카카오채널과 인스타그램에서 사역자모아를 만나보세요</p>
            </div>
            <div className="main__cta__actions">
              <a
                href='http://pf.kakao.com/_Xzwrn'
                target='_blank'
                rel="noopener noreferrer"
                className="main__cta__btn main__cta__btn--kakao"
              >
                <img src={kakaologo} alt="카카오" /> 카카오채널
              </a>
              <a
                href='https://www.instagram.com/ministermore.co.kr'
                target='_blank'
                rel="noopener noreferrer"
                className="main__cta__btn main__cta__btn--insta"
              >
                <img src={instarlogo} alt="인스타" /> 인스타그램
              </a>
            </div>
          </div>
        </div>
      </div>

			<ScrollToTopButton />
			<Footer />
		</div>
	);
}